module.exports = __webpack_public_path__ + "8fb0b9355f5aa84e6660a52601949397.jpg";